module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("g4ze7"))).then(() => parcelRequire('1iHdE'));